import i18n from '../../../../i18n';
import {
  MetricCategoryId,
  MetricGroupId,
  MetricId,
} from '../../../common/graphql/generated/graphql-sdk';
import { MetricStore } from '../../../common/metrics/metric-store';
import { ExportRowDataObjKeys } from './balance-sheet-store';
import { SegmentValTypes } from './types';

export const getPbsMeasureLabel = (measure: MetricId) => {
  return i18n.t(`pages:dashboards.peopleBalanceSheet.pbsMeasures.${measure}`);
};

export const periodTrend = i18n.t(
  `pages:dashboards.peopleBalanceSheet.table.periodTrend`
);

export const overTimeTitle = i18n.t(
  'pages:dashboards.peopleBalanceSheet.MetricOverTimeChart.overTime'
);

export const getExportRowDataObjKeyTranslation = (
  key: ExportRowDataObjKeys
) => {
  return i18n.t(`pages:dashboards.peopleBalanceSheet.export.${key}`);
};

export const getTranslatedTableNameFromKey = (key: string) => {
  return i18n.t(`pages:dashboards.peopleBalanceSheet.table.${key}`);
};

export const getDisplayMetricGroupName = (
  metricGroupId: MetricGroupId,
  alias: string | null,
  metricStore: MetricStore
): string => {
  return alias || metricStore.getTranslatedMetricGroupName(metricGroupId);
};

export const getDisplayMetricCategoryName = (
  metricCategoryId: MetricCategoryId,
  alias: string | null,
  metricStore: MetricStore
): string => {
  return alias || metricStore.getTranslatedMetricCategoryName(metricCategoryId);
};

export const getPbsSegmentMeasureLabel = (segmentMeasure: SegmentValTypes) => {
  return i18n.t(
    `pages:dashboards.peopleBalanceSheet.segmentMeasures.${segmentMeasure}`
  );
};
